<template>
<div>
  <ul :id="zt_id" class="ztree"></ul>
</div>
</template>

<script>
import '@ztree/ztree_v3/js/jquery-1.4.4.min'
import '@ztree/ztree_v3/js/jquery.ztree.core.min'
import '@ztree/ztree_v3/js/jquery.ztree.excheck.min'
import '@ztree/ztree_v3/js/jquery.ztree.exedit.min'
import '@ztree/ztree_v3/js/jquery.ztree.exhide.min'
// import '@ztree/ztree_v3/css/metroStyle/metroStyle.css'
import '@ztree/ztree_v3/css/zTreeStyle/zTreeStyle.css'
import {fuzzySearch,throttle} from "./fuzzysearch";
export default {
  name: "ZTree",
  props:{
    isCheck:{
      type:Boolean,
      default(){
        return false
      }
    },
    nodeData:{
      type:Array,
      default(){
        return[]
      }
    },
    setting: {
      type:Object,
      default(){
        return{}
      }
    }
  },
  data(){
    return{
      zt_id:"ztree_" + parseInt(Math.random() * 1e10),
      zTreeObj:null,
      setting2:{
        treeId: this.zt_id,
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pid',
            rootPId: 0
          },
          key: {
            name: 'name', //需要显示的字段名称
          },
        },
        check: {
          enable: this.isCheck,  //true 、 false 分别表示 显示 、不显示 复选框或单选框
          nocheckInherit: true  //当父节点设置 nocheck = true 时，设置子节点是否自动继承 nocheck = true
        },
        callback: {
          // // 树的点击事件
          onClick: this.onClick,//点击回调
          onCheck: this.onCheck, //点击选中 checkbox
          // onAsyncSuccess: this.zTreeOnAsyncSuccess,//异步加载成功的fun
          // beforeAsync: this.zTreeBeforeAsync,//异步加载前的回调
          // onExpand: this.expandNode//节点展开回调
        },
        edit: {//是否支持拖拽，enable我改成了false,代表此功能禁用，也可以直接删除，为了防止后续他们提这个需求，所以我还是写上了
          // drag: {
          //   isMove: true,
          //   prev: true,
          //   next: true,
          //   inner: true
          // },
          enable: false,
          showRemoveBtn: false,
          showRenameBtn: false
        },
        view: {
          // addHoverDom:this.addhoverdom,//ztree提供的可以自定义添加dom
          // removeHoverDom:this.removehoverdom,//和addHoverDom成对出现，离开节点时需要移除自定义的dom
          // fontCss: function (treeId, treeNode) {//设置所有节点的样式，我这里的代码的意思是，当前节点是否高亮（树节点搜索的时候会高亮命中的节点），高亮就设置节点高亮样式，否则就是普通样式
          //     return (!!treeNode.highlight) ? {'backgroundColor':'#F6F7F8','display':'inline-block','width':'95%','min-width':'225px','padding':'3px 0'} : {
          //             color: "#000000", "font-weight": "normal"
          //         };
          // },
          showTitle: true //是否显示titie属性（就是鼠标放到节点上是否显示html元素的title属性）
        },
        // async:{//节点很多的情况下设置懒加载
        //     enable:true,//是否开启异步加载模式
        //     contentType: "application/json",//Ajax 提交参数的数据类型
        //     dataType: "json",//Ajax 获取的数据类型
        //     // url:'/aa/bbb/ccc/loadTree',//点击树的展开节点，会重新加载子节点，这里是请求的url地址
        //     type:'POST',//当前的请求类型
        //     // autoParam:['id=parentId'],//将节点的pId值作为参数传递
        //     // otherParam:{'userId':()=>{return this.userId;},'userName':()=>{return this.userName;},'tenantId':()=>{return this.tenantId;}}
        //     otherParam:{'userId':this.userId,'userName':this.userName,'tenantId':this.tenantId,'parentId':'-'},//每次异步请求携带的参数
        //     dataFilter:function(treeId, parentNode, resp){
        //         sessionStorage.setItem('tongbunodes',JSON.stringify(resp.jsSubjects.children));
        //         return resp.subjects;
        //     }//对 Ajax 返回数据进行预处理的函数,就是异步加载返回的数据你可以处理一下再用
        // }
      },
      expandNode:[],
      firstNode:null
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.init();
  },
  methods:{
    initData(){
      if(this.setting){
        Object.assign(this.setting2,ERP.reJson(this.setting));
      }
    },
    init(){
      if(this.setting2){
        this.zTreeObj = $.fn.zTree.init($("#"+this.zt_id), this.setting2, createTree(0,this.nodeData,this.setting2.data.simpleData.idKey,this.setting2.data.simpleData.pIdKey));
      }
    },
    onClick(event, treeId, treeNode){
      this.$emit("onClick",treeNode)
    },
    onCheck(event, treeId, treeNode){
      let nodes=this.zTreeObj.getCheckedNodes(true);
      this.$emit("onCheck",nodes)
    },
    search(val){
      const that=this;
      throttle(function () {
        fuzzySearch(that.zTreeObj,val)
      },500,that);
    }
  },
  watch:{
    setting:{
      immediate:true,
      deep:true,
      handler(n){
        if(n){
          Object.assign(this.setting2,ERP.reJson(n));
          this.init();
        }
      }
    },
    nodeData:{
      immediate:true,
      deep:true,
      handler(n){
        this.init();
      }
    }
  }
}

const createTree = (pid=0,list=[],idKey='id',pidKey='pid') => {
  return list.filter(ret=>ret[pidKey]===pid).map(ret=>{
    if(list.findIndex(ret2=>ret2[pidKey]===ret[idKey])!==-1){
      ret.children=createTree(ret[idKey],list,idKey,pidKey)
    }
    return ret;
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ztree/ZTree.vue